module.exports = __webpack_public_path__ + "media/stylesheets/images/check-4afc355ac64996ab2acd549d78f47e01.png";